import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Input, Button, Row, Typography,message, Flex } from 'antd';
import { useNavigate } from "react-router-dom"
import { EyeTwoTone, EyeInvisibleOutlined, LockOutlined } from '@ant-design/icons';
import './Auth.css';

import { PasswordRequirements } from '../../components/UI/PasswordRequirements.component';
import { isValidPassword } from '../../Validation';
import { resetPassword } from '../../services/UserService';

const { Title, } = Typography;

export const ResetPassword = ({...props}) => {

    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [params, setParams] = useState({})
    const [form] = Form.useForm();

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        setParams({ email: queryParams.get('email'), token: queryParams.get('token'), username:  queryParams.get('username'), mode:  queryParams.get('mode')})
    }, [])
    

    const checkPasswordRequirements = () => {
        return (
            <div style={{backgroundColor: 'var(--gray-3)', padding: 10, marginTop: -5, marginBottom: 10}}>
                <p><strong>Password Requirements:</strong></p> 
                <PasswordRequirements password={newPassword}/>
            </div>
        );
    }

    const onFinish = (data) => {
        Object.assign(data, {...params})
        resetPassword(data).then(function (response) {
            if( !response.success ) {
                message.error(response.message, 5)
                if (!response.token )
                    navigate('/forgot-password');
                return;
            }
            message.success(response.message)
            navigate('/')
        })
    }

    return (
        <>
            <Row>
                <Form
                    form={form}
                    name="reset-password"
                    className="form-container"
                    size='default'
                    autoComplete='off'
                    layout='vertical'
                    onFinish={(data) => onFinish(data)} 
                >   
                    <Title level={1}>Reset password</Title>
                    
                    <Form.Item
                        name="password"
                        label="New Password:"
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: '*Required'
                            },
                            () => ({
                                validator(_, value) {
                                    setNewPassword(value);
                                    if (value && isValidPassword(value)){
                                        return Promise.resolve();
                                    } 
                                    return Promise.reject();
                                    },
                                }),
                            ]}
                        >
                        <Input.Password autoComplete='off' addonBefore={<LockOutlined />} showCount iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>

                    {newPassword && !isValidPassword(newPassword) ? checkPasswordRequirements() : null}

                    <Form.Item
                        name="confirmPassword"
                        label="Confirm Password:"
                        dependencies={['account-new-password']}
                        hasFeedback
                        rules={[
                            { 
                                required: true, 
                                message: "*Required"
                            }, 
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if(!value || getFieldValue('password') === value){
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('Both passwords must match'))
                                }
                            }),
                        ]}
                        >
                        <Input.Password autoComplete='off' addonBefore={<LockOutlined />} allowClear iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                    </Form.Item>
                    <Flex vertical gap='middle'>
                        <Button
                            type='primary'
                            block
                            className='btn-block'
                            htmlType='submit'
                        >
                            Create new password
                        </Button>                 
                        <Link to='/'>
                            <Button type='link' block>Back to Login</Button>
                        </Link>
                    </Flex>
                </Form>
            </Row>
        </>
    )
}